import React, { useContext } from "react";
import { DashboardContext } from "../Self-Verification Tool/DashboardContext";
import HitachiTopLogo from "../../resources/topLogo";
import StackedBarGraph from "./StackedBarGraph";
import dashboardDataConfig from "../Self-Verification Tool/config/dashboardDataConfig";
import "./Dashboard.css";

const Dashboard = () => {
    const { selectedDashboard } = useContext(DashboardContext);
    
    const renderDashboard = () => {
        const dashboard = dashboardDataConfig.find(
        (d) => d.dashboardName?.toLowerCase().trim() === selectedDashboard?.toLowerCase().trim()
        );

        return (
            dashboard && (
                <StackedBarGraph
                    data={dashboard?.data}
                    options={dashboard?.options}
                    primaryFilters={dashboard?.primaryFilters}
                    secondaryFilters={dashboard?.secondaryFilters}
                    selectedDashboard={selectedDashboard}
                />
            )
        );
    };

    return (
        <div className="dashboard-container">
            <div className="dashboard-header">
                <HitachiTopLogo />
                <div className="dashboard-main">{renderDashboard()}</div>
            </div>
        </div>
    );
};

export default Dashboard;
